(()=>{
  const esc = (s) => String(s ?? '').replace(/[&<>'"]/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  const slug = (s) => encodeURIComponent(String(s).trim().replace(/\s+/g,'-'));
  const key = (s) => String(s || '').trim().toLowerCase();
  const slugKey = (s) => key(s).replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
  const first = (...values) => values.find((v) => typeof v === 'string' && v.trim()) || '';
  const editorialPack = window.OPS_OCCULT_EDITORIAL || {entries:[]};
  const taxonomy = window.OPS_OCCULT_TAXONOMY || {depths:[],topics:[]};
  const editorial = new Map((editorialPack.entries || []).map((x) => [key(x.title), x]));
  const originalTitle = document.title;
  const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
  const depthOrder = (taxonomy.depths || []).map((x)=>x.name);

  const paragraphs = (value) => {
    if (!value) return '';
    const parts = Array.isArray(value) ? value : String(value).split(/\n\s*\n|\r?\n/);
    return parts.map((x) => String(x).trim()).filter(Boolean).map((x) => `<p>${esc(x)}</p>`).join('');
  };
  const section = (title, body, className='') => body ? `<section class="ops-library__article-section${className ? ` ${className}` : ''}"><h3>${esc(title)}</h3>${body}</section>` : '';
  const editorialSections = (sections) => (sections || []).map((s) => section(s.heading, paragraphs(s.paragraphs))).join('');
  const editorialSummary = (x) => ({title:x.title, synopsis:x.synopsis || '', editorial:true, depth:x.depth || '', type:x.type || '', categories:x.categories || []});
  const isPublishedRemote = (x={}) => {
    const status = key(x.publish_status || x.ops_status || x.status);
    return status === 'published' || x.ops_published === true || x.published === true;
  };
  const depthMeta = (name) => (taxonomy.depths || []).find((x)=>x.name===name) || {name,description:''};
  const topicMetaFor = (entry) => (taxonomy.topics || []).filter((topic)=>(topic.entries || []).includes(entry.title));

  const init = async (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const api = (root.dataset.api || '').replace(/\/$/, '');
    const results = root.querySelector('[data-library-results]');
    const status = root.querySelector('[data-library-status]');
    const form = root.querySelector('[data-library-search]');
    const input = root.querySelector('[data-library-input]');
    const reader = root.querySelector('[data-library-reader]');
    const index = root.querySelector('[data-library-index]');
    const article = root.querySelector('[data-library-article]');
    const ghost = root.querySelector('[data-library-ghost]');
    const iceberg = root.querySelector('[data-library-iceberg]');
    const topics = root.querySelector('[data-library-topics]');
    const az = root.querySelector('[data-library-az]');
    const azResults = root.querySelector('[data-library-az-results]');
    const browseTabs = root.querySelector('[data-library-browse-tabs]');
    const browsePanels = [...root.querySelectorAll('[data-library-browse-panel]')];
    const studyAssets = {
      pentagram: root.dataset.studyPentagram || '',
      pentagramPoints: root.dataset.studyPentagramPoints || '',
      magicSquare: root.dataset.studyMagicSquare || '',
      kameaTrace: root.dataset.studyKameaTrace || '',
      fibonacci: root.dataset.studyFibonacci || '',
      fibonacciSequence: root.dataset.studyFibonacciSequence || '',
      zodiac: root.dataset.studyZodiac || '',
      zodiacGlyphs: root.dataset.studyZodiacGlyphs || ''
    };
    const studyImage = (src, alt, support='') => src ? `<div class="ops-library__study-stack"><img class="ops-library__study-main" src="${esc(src)}" alt="${esc(alt)}" loading="lazy">${support ? `<img class="ops-library__study-support" src="${esc(support)}" alt="" loading="lazy" aria-hidden="true">` : ''}</div>` : '';
    let all = [];

    const get = async (path) => {
      const r = await fetch(api + path, {headers:{Accept:'application/json'}, cache:'no-store'});
      if (!r.ok) throw Error(`Couldn’t load the archive (${r.status})`);
      return r.json();
    };

    const combined = (apiList=[]) => {
      const map = new Map();
      (apiList || []).filter(isPublishedRemote).forEach((x) => map.set(key(x.title), x));
      (editorialPack.entries || []).forEach((x) => map.set(key(x.title), {...map.get(key(x.title)), ...editorialSummary(x)}));
      return [...map.values()].sort((a,b) => String(a.title).localeCompare(String(b.title)));
    };

    const draw = (list) => {
      results.innerHTML = list.length ? list.map((x) => `
        <article class="ops-library__item${x.editorial ? ' is-editorial' : ''}" tabindex="0" role="button" data-title="${esc(x.title)}">
          <div class="ops-library__item-title"><h3>${esc(x.title)}</h3>${x.depth ? `<span>${esc(x.depth)}</span>` : ''}</div>
          ${x.synopsis ? `<p>${esc(x.synopsis)}</p>` : ''}
          <span class="ops-library__arrow" aria-hidden="true">↗</span>
        </article>`).join('') : '<div class="ops-library__loading">Nothing matched that search.</div>';
      status.textContent = `${list.length} ${list.length === 1 ? 'entry' : 'entries'} shown`;
    };

    const showBrowse = (name) => {
      browseTabs?.querySelectorAll('[data-browse-tab]').forEach((b)=>b.setAttribute('aria-current', String(b.dataset.browseTab===name)));
      browsePanels.forEach((p)=>{ p.hidden = p.dataset.libraryBrowsePanel !== name; });
    };

    const drawIceberg = () => {
      if (!iceberg) return;
      const groups = new Map();
      (editorialPack.entries || []).forEach((x) => {
        if (!x.depth) return;
        if (!groups.has(x.depth)) groups.set(x.depth, []);
        groups.get(x.depth).push(x);
      });
      const ordered = depthOrder.filter((name)=>groups.has(name)).map((name)=>[name,groups.get(name)]);
      if (!ordered.length) { iceberg.remove(); return; }
      iceberg.innerHTML = `
        <div class="ops-library__iceberg-head">
          <p class="ops-library__eyebrow">THE OCCULT ICEBERG</p>
          <h2>Start familiar. Keep going down.</h2>
          <p>The surface holds the names most people recognise. Lower down, the archive becomes more specific, older and stranger. Every visible term is a finished entry you can open now.</p>
          <button class="ops-library__random" type="button" data-random-rabbit>Drop me somewhere strange <span aria-hidden="true">↝</span></button>
        </div>
        <div class="ops-library__iceberg-ocean">
          ${ordered.map(([depth,items],idx) => {
            const meta=depthMeta(depth);
            return `<section class="ops-library__iceberg-level" data-depth="${idx+1}" data-depth-name="${esc(slugKey(depth))}">
              <div class="ops-library__iceberg-label"><span>${esc(depth)}</span>${meta.description ? `<p>${esc(meta.description)}</p>` : ''}</div>
              <div class="ops-library__iceberg-terms">${items.map((x) => `<button type="button" data-title="${esc(x.title)}"><strong>${esc(x.title)}</strong><small>${esc(x.type || '')}</small></button>`).join('')}</div>
            </section>`;
          }).join('')}
        </div>`;
    };

    const drawTopics = () => {
      if (!topics) return;
      const finished = new Set((editorialPack.entries || []).map((x)=>x.title));
      topics.innerHTML = (taxonomy.topics || []).map((topic)=>{
        const entries=(topic.entries || []).filter((name)=>finished.has(name));
        if(!entries.length) return '';
        return `<section class="ops-library__topic-card" data-topic-name="${esc(topic.name)}">
          <p class="ops-library__eyebrow">${esc(topic.kicker || 'ARCHIVE TRAIL')}</p>
          <h3>${esc(topic.name)}</h3>
          <p>${esc(topic.description || '')}</p>
          <div class="ops-library__topic-links">${entries.map((name)=>`<button type="button" data-title="${esc(name)}">${esc(name)} <span aria-hidden="true">↗</span></button>`).join('')}</div>
        </section>`;
      }).join('');
    };

    const drawAZ = (letter='A') => {
      if (!az || !azResults) return;
      const counts = new Map(alphabet.map((l)=>[l,0]));
      all.forEach((x)=>{ const l=String(x.title || '').trim().charAt(0).toUpperCase(); if(counts.has(l)) counts.set(l,counts.get(l)+1); });
      const active = counts.get(letter) ? letter : alphabet.find((l)=>counts.get(l)) || 'A';
      az.innerHTML = alphabet.map((l)=>`<button type="button" data-letter="${l}" ${counts.get(l) ? '' : 'disabled'} ${l===active ? 'aria-current="true"' : ''}>${l}<small>${counts.get(l) || ''}</small></button>`).join('');
      const list=all.filter((x)=>String(x.title || '').trim().toUpperCase().startsWith(active));
      azResults.innerHTML = `<div class="ops-library__az-letter">${active}</div><div class="ops-library__az-list">${list.map((x)=>`<button type="button" data-title="${esc(x.title)}"><strong>${esc(x.title)}</strong>${x.synopsis ? `<span>${esc(x.synopsis)}</span>` : ''}</button>`).join('')}</div>`;
    };

    const startGhostWriting = () => {
      if (!ghost) return;
      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const source = (editorialPack.entries || []).filter((x)=>x && x.title && (x.synopsis || (x.lead && x.lead.length)));
      if (!source.length) return;
      const shuffle = (arr) => arr.map((value)=>({value,sort:Math.random()})).sort((a,b)=>a.sort-b.sort).map((x)=>x.value);
      const makePhrase = (entry) => {
        const detail = entry.synopsis || (entry.lead && entry.lead[0]) || '';
        return `${entry.title}. ${detail}`.replace(/\s+/g,' ').trim();
      };
      const lines = Array.from({length:5},(_,i)=>{
        const p=document.createElement('p');
        p.dataset.ghostLine=String(i);
        ghost.appendChild(p);
        return p;
      });
      let cycle = shuffle(source);
      let cursor = 0;
      const nextEntry = () => {
        if (cursor >= cycle.length) { cycle = shuffle(source); cursor = 0; }
        return cycle[cursor++];
      };
      const write = (node,text,delay=0) => {
        if (reduceMotion) { node.textContent=text; node.classList.add('is-set'); return; }
        node.textContent='';
        node.classList.remove('is-set','is-fading');
        node.classList.add('is-writing');
        let i=0;
        const tick=()=>{
          if(i < text.length){
            const step = text.charAt(i)===' ' ? Math.min(2,text.length-i) : 1;
            i=Math.min(text.length,i+step);
            node.textContent=text.slice(0,i);
            window.setTimeout(tick, 42 + Math.floor(Math.random()*48));
          } else {
            // Keep the finished sentence complete. The atmosphere changes only as a whole line,
            // never by dropping individual characters out of readable words.
            node.textContent=text;
            node.classList.remove('is-writing');
            node.classList.add('is-set');
            window.setTimeout(()=>{
              node.classList.add('is-fading');
              window.setTimeout(()=>write(node,makePhrase(nextEntry()),0),2400);
            },22000 + Math.floor(Math.random()*12000));
          }
        };
        window.setTimeout(tick,delay);
      };
      lines.forEach((node,i)=>write(node,makePhrase(nextEntry()),i*3300));
    };

    const relatedMarkup = (items=[]) => items.length ? `<div class="ops-library__rabbit-links">${items.map((name)=>{
      const local=editorial.get(key(name));
      return `<button type="button" data-related-title="${esc(name)}"><strong>${esc(name)}</strong>${local?.synopsis ? `<span>${esc(local.synopsis)}</span>` : ''}</button>`;
    }).join('')}</div>` : '';

    const catalogueMarkup = (items=[]) => items.length ? `<div class="ops-library__catalogue-links">${items.map((x)=>`<a href="${esc(x.url)}"><span>${esc(x.label)}</span><b aria-hidden="true">→</b></a>`).join('')}</div>` : '';


    const safeVideoId = (value='') => String(value).replace(/[^A-Za-z0-9_-]/g,'');
    const mediaMarkup = (items=[]) => {
      if (!items.length) return '';
      return `<section class="ops-library__media-shelf" aria-label="Media references">
        <div class="ops-library__media-head"><p class="ops-library__eyebrow">WATCH / LISTEN / INSPECT</p><h3>Media reference</h3><p>Embedded media stays attached to the entry that gives it context. A recording can be authentic without every interpretation of it being true.</p></div>
        <div class="ops-library__media-grid">${items.map((m)=>{
          if(m.kind==='youtube'){
            const id=safeVideoId(m.videoId);
            if(!id) return '';
            return `<article class="ops-library__media-item ops-library__media-item--video"><div class="ops-library__video-frame"><iframe src="https://www.youtube-nocookie.com/embed/${id}" title="${esc(m.title || 'YouTube video')}" loading="lazy" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe></div><div class="ops-library__media-copy"><span>${esc(m.creator || 'Video reference')}${m.year ? ` · ${esc(m.year)}` : ''}</span><h4>${esc(m.title || 'Video')}</h4>${m.note ? `<p>${esc(m.note)}</p>` : ''}<a href="https://www.youtube.com/watch?v=${id}" target="_blank" rel="noopener noreferrer">Open on YouTube ↗</a></div></article>`;
          }
          return `<article class="ops-library__media-item ops-library__media-item--external"><div class="ops-library__media-mark" aria-hidden="true">◉</div><div class="ops-library__media-copy"><span>${esc(m.creator || 'External media')}${m.year ? ` · ${esc(m.year)}` : ''}</span><h4>${esc(m.title || 'Media reference')}</h4>${m.note ? `<p>${esc(m.note)}</p>` : ''}${m.url ? `<a href="${esc(m.url)}" target="_blank" rel="noopener noreferrer">Open source ↗</a>` : ''}</div></article>`;
        }).join('')}</div>
      </section>`;
    };

    const evidenceMarkup = (evidence) => evidence?.note ? `<aside class="ops-library__evidence-note"><span>${esc(evidence.label || 'Archive status')}</span><p>${esc(evidence.note)}</p></aside>` : '';

    const sourcesMarkup = (items=[]) => items.length ? `<section class="ops-library__source-shelf"><p class="ops-library__eyebrow">REFERENCE SHELF</p><h3>Sources & further reading</h3><div>${items.map((x)=>`<a href="${esc(x.url)}" target="_blank" rel="noopener noreferrer"><span>${esc(x.type || 'Reference')}</span><strong>${esc(x.label)}</strong><b aria-hidden="true">↗</b></a>`).join('')}</div></section>` : '';

    const referenceMarkup = (r={}) => {
      const rows=[['Period',r.period],['Place',r.place],['Tradition',r.tradition],['Source status',r.status]].filter(([,v])=>v);
      return rows.length ? `<div class="ops-library__reference-context"><span>Reference context</span><dl>${rows.map(([k,v])=>`<div><dt>${esc(k)}</dt><dd>${esc(v)}</dd></div>`).join('')}</dl></div>` : '';
    };

    const rabbitTrailMarkup = (p) => {
      const currentDepth = depthOrder.indexOf(p.depth);
      const relatedEntries = (p.related || []).map((name)=>editorial.get(key(name))).filter(Boolean);
      const deeperPool = relatedEntries.filter((x)=>depthOrder.indexOf(x.depth) > currentDepth);
      const nextDepth = currentDepth >= 0 && currentDepth < depthOrder.length - 1 ? depthOrder[currentDepth + 1] : '';
      if (nextDepth) (editorialPack.entries || []).filter((x)=>x.depth===nextDepth && x.title!==p.title).forEach((x)=>{ if(!deeperPool.some((d)=>d.title===x.title)) deeperPool.push(x); });
      const deeper = deeperPool.slice(0,4);
      const deeperNames = new Set(deeper.map((x)=>x.title));
      const related = relatedEntries.filter((x)=>!deeperNames.has(x.title)).slice(0,4);
      const broader = topicMetaFor(p).slice(0,4);
      if (!related.length && !deeper.length && !broader.length) return '';
      const entryButtons=(items)=>items.map((x)=>`<button type="button" data-related-title="${esc(x.title)}"><strong>${esc(x.title)}</strong>${x.synopsis ? `<span>${esc(x.synopsis)}</span>` : ''}</button>`).join('');
      return `<section class="ops-library__rabbit-trails" aria-label="Continue through the archive">
        ${related.length ? `<div><p class="ops-library__eyebrow">RELATED</p><h3>Along the same shelf</h3>${entryButtons(related)}</div>` : ''}
        ${deeper.length ? `<div><p class="ops-library__eyebrow">GO DEEPER</p><h3>Further down the iceberg</h3>${entryButtons(deeper)}</div>` : ''}
        ${broader.length ? `<div><p class="ops-library__eyebrow">BROADER</p><h3>Open the wider subject</h3>${broader.map((t)=>`<button type="button" data-topic-jump="${esc(t.name)}"><strong>${esc(t.name)}</strong><span>${esc(t.description || '')}</span></button>`).join('')}</div>` : ''}
      </section>`;
    };

    const explainerMarkup = (p) => {
      const s = slugKey(p.title);
      if (s === 'pentagram') return `<section class="ops-library__visual-note ops-library__visual-note--pentagram">
        <div class="ops-library__visual-canvas">${studyImage(studyAssets.pentagram,'Hand-drawn construction study of a five-pointed pentagram inside a circle',studyAssets.pentagramPoints)}</div>
        <div class="ops-library__visual-copy"><p class="ops-library__eyebrow">PENCIL STUDY · GEOMETRY</p><h3>Five points. One star polygon.</h3><p>A pentagram is the five-pointed star polygon usually written {5/2}: five points around a circle joined by stepping to every second point. The crossings create a smaller central pentagon and repeating proportions related to the golden ratio.</p><dl><div><dt>5</dt><dd>outer points</dd></div><div><dt>{5/2}</dt><dd>star polygon</dd></div><div><dt>φ</dt><dd>appears in segment ratios</dd></div></dl><p class="ops-library__visual-note-small">Meanings and orientation vary by period and tradition; the geometry is the stable part.</p></div>
      </section>`;

      if (s === 'magic-squares') return `<section class="ops-library__visual-note ops-library__visual-note--square">
        <div class="ops-library__visual-canvas">${studyImage(studyAssets.magicSquare,'Hand-drawn three by three magic square in which rows, columns and diagonals each total fifteen',studyAssets.kameaTrace)}</div>
        <div class="ops-library__visual-copy"><p class="ops-library__eyebrow">PENCIL STUDY · NUMBER GRID</p><h3>Different routes, the same total.</h3><p>This classic 3 × 3 normal magic square uses the numbers 1–9 once each. Every row, every column and both main diagonals add to 15. That balancing trick is why magic squares became such durable mathematical and occult diagrams.</p><dl><div><dt>3 × 3</dt><dd>nine cells</dd></div><div><dt>1–9</dt><dd>used once</dd></div><div><dt>15</dt><dd>magic constant</dd></div></dl><p class="ops-library__visual-note-small">Later Western occult systems assigned different orders of magic square to planets. That is a separate tradition from Goetic spirit seals.</p></div>
      </section>`;

      if (s === 'fibonacci-sequence') return `<section class="ops-library__visual-note ops-library__visual-note--fibonacci">
        <div class="ops-library__visual-canvas">${studyImage(studyAssets.fibonacci,'Hand-drawn Fibonacci squares with a quarter-circle spiral approximation',studyAssets.fibonacciSequence)}</div>
        <div class="ops-library__visual-copy"><p class="ops-library__eyebrow">PENCIL STUDY · GROWTH</p><h3>Each number remembers the two before it.</h3><p>In the familiar Fibonacci sequence, each term is the sum of the previous two: 1, 1, 2, 3, 5, 8, 13, 21… Ratios between neighbouring terms approach the golden ratio as the sequence grows.</p><dl><div><dt>1,1,2</dt><dd>the opening</dd></div><div><dt>a+b</dt><dd>builds the next term</dd></div><div><dt>φ</dt><dd>the ratio is approached</dd></div></dl><p class="ops-library__visual-note-small">The familiar “Fibonacci spiral” drawn through adjoining squares is a quarter-circle approximation; it is not literally the same curve as a mathematical golden spiral.</p></div>
      </section>`;

      if (s === 'zodiac') return `<section class="ops-library__visual-note ops-library__visual-note--zodiac">
        <div class="ops-library__visual-canvas">${studyImage(studyAssets.zodiac,'Hand-drawn zodiac circle divided into twelve equal thirty-degree signs',studyAssets.zodiacGlyphs)}</div>
        <div class="ops-library__visual-copy"><p class="ops-library__eyebrow">PENCIL STUDY · CELESTIAL FRAME</p><h3>Twelve equal signs around one circle.</h3><p>Astrological zodiac signs divide a full circle into twelve equal 30° sections along the ecliptic. The named constellations that inspired them are real star patterns with irregular astronomical boundaries, so “sign” and “constellation” are related but not interchangeable.</p><dl><div><dt>12</dt><dd>signs</dd></div><div><dt>30°</dt><dd>per sign</dd></div><div><dt>360°</dt><dd>full circle</dd></div></dl><p class="ops-library__visual-note-small">Tropical and sidereal zodiacs use the same twelve sign names but anchor the framework differently.</p></div>
      </section>`;
      return '';
    };

    const positionMarkup = (p) => {
      const d = depthMeta(p.depth || '');
      const entryTopics = topicMetaFor(p);
      const idx = depthOrder.indexOf(p.depth);
      const shallower = idx > 0 ? (editorialPack.entries || []).filter((x)=>x.depth===depthOrder[idx-1]).slice(0,2) : [];
      const deeper = idx >= 0 && idx < depthOrder.length-1 ? (editorialPack.entries || []).filter((x)=>x.depth===depthOrder[idx+1]).slice(0,2) : [];
      return `<aside class="ops-library__entry-map">
        <div><span>Iceberg depth</span><strong>${esc(p.depth || 'Archive')}</strong>${d.description ? `<p>${esc(d.description)}</p>` : ''}</div>
        ${referenceMarkup(p.reference || {})}
        ${entryTopics.length ? `<div><span>Found under</span><div class="ops-library__entry-topic-list">${entryTopics.map((t)=>`<button type="button" data-topic-jump="${esc(t.name)}">${esc(t.name)}</button>`).join('')}</div></div>` : ''}
        ${(shallower.length || deeper.length) ? `<div class="ops-library__depth-neighbours">${shallower.length ? `<span>Closer to the surface</span>${shallower.map((x)=>`<button type="button" data-related-title="${esc(x.title)}">${esc(x.title)}</button>`).join('')}` : ''}${deeper.length ? `<span>Further down</span>${deeper.map((x)=>`<button type="button" data-related-title="${esc(x.title)}">${esc(x.title)}</button>`).join('')}` : ''}</div>` : ''}
      </aside>`;
    };

    const renderEditorial = (p) => {
      const lead = p.lead?.length ? `<div class="ops-library__article-lead">${paragraphs(p.lead)}</div>` : '';
      const rabbitTrails = rabbitTrailMarkup(p);
      const catalogue = catalogueMarkup(p.catalogue || []);
      const explainer = explainerMarkup(p);
      const media = mediaMarkup(p.media || []);
      const evidence = evidenceMarkup(p.evidence);
      const sources = sourcesMarkup(p.sources || []);
      const art = p.illustration ? `<figure class="ops-library__article-art"><img src="${esc(p.illustration.url)}" alt="${esc(p.illustration.alt || p.title)}" loading="eager"></figure>` : '';
      return `<div class="ops-library__article ops-library__article--editorial">
        <header class="ops-library__entry-hero">
          <div>
            <p class="ops-library__eyebrow">OPS OCCULT ARCHIVE · ${esc(p.depth || 'RABBIT HOLE')}</p>
            <h2>${esc(p.title)}</h2>
            ${p.type ? `<p class="ops-library__article-type">${esc(p.type)}</p>` : ''}
          </div>
          ${art}
        </header>
        <div class="ops-library__entry-layout">
          <div class="ops-library__entry-copy">${lead}${evidence}${media}${explainer}${editorialSections(p.sections)}${sources}${rabbitTrails}${catalogue ? section('Make something from it', catalogue) : ''}</div>
          ${positionMarkup(p)}
        </div>
      </div>`;
    };

    const renderApi = (d,title) => {
      const p = d.page || {};
      if(!isPublishedRemote(p)) return `<div class="ops-library__article"><h2>That entry isn’t available</h2><p>Try the A–Z index, the iceberg or another related term.</p></div>`;
      const tags = (d.categories || []).map((x) => `<span class="ops-library__tag">${esc(x.name)}</span>`).join('');
      const related = (d.internal_links || []).slice(0,14).map((x) => `<button type="button" class="ops-library__tag" data-related-title="${esc(x.target_title)}">${esc(x.target_title)}</button>`).join('');
      const overview = first(p.ops_overview,p.overview,p.long_summary,p.synopsis);
      const history = first(p.ops_history,p.history,p.background);
      const meaning = first(p.ops_meaning,p.meaning,p.significance);
      const practice = first(p.ops_practice,p.usage,p.use,p.practice);
      const variations = first(p.ops_variations,p.variations,p.variants);
      const notes = first(p.ops_public_notes,p.public_notes);
      const image = first(p.ops_illustration_url,p.ops_image_url);
      const imageAlt = first(p.ops_illustration_alt, `${p.title || title} — OPS archive illustration`);
      const illustration = image ? `<figure class="ops-library__article-art"><img src="${esc(image)}" alt="${esc(imageAlt)}" loading="lazy"></figure>` : '';
      const intro = overview ? `<div class="ops-library__article-lead">${paragraphs(overview)}</div>` : '';
      return `<div class="ops-library__article">
        <p class="ops-library__eyebrow">OPS OCCULT ARCHIVE</p>
        <h2>${esc(p.title || title)}</h2>
        ${illustration}${intro}
        ${section('Background', paragraphs(history))}
        ${section('Meaning & symbolism', paragraphs(meaning))}
        ${section('How it appears in practice', paragraphs(practice))}
        ${section('Variations', paragraphs(variations))}
        ${tags ? section('Explore nearby', `<div class="ops-library__tags">${tags}</div>`) : ''}
        ${related ? section('Related terms', `<div class="ops-library__tags">${related}</div>`) : ''}
        ${section('Archive notes', paragraphs(notes))}
      </div>`;
    };

    const setTermUrl = (title,replace=false) => {
      const url = new URL(location.href);
      if (title) url.searchParams.set('term', slugKey(title)); else url.searchParams.delete('term');
      history[replace ? 'replaceState' : 'pushState']({opsTerm:title || ''},'',url);
    };

    const resetEntryScroll = (behavior='auto') => {
      requestAnimationFrame(() => {
        const target = reader?.querySelector('.ops-library__reader-nav') || reader;
        if (target) target.scrollIntoView({ block: 'start', behavior });
      });
    };

    const showReader = () => {
      if (reader) reader.hidden = false;
      if (index) index.hidden = true;
      root.classList.add('is-reading');
    };

    const open = async (title, opts={}) => {
      const local = editorial.get(key(title));
      article.innerHTML = '<div class="ops-library__article"><p>Opening entry…</p></div>';
      showReader();
      resetEntryScroll('auto');
      try {
        if (local) {
          article.innerHTML = renderEditorial(local);
          document.title = `${local.title} — OPS Occult Archive`;
          if (!opts.fromUrl) setTermUrl(local.title, !!opts.replace);
          resetEntryScroll(opts.fromUrl ? 'auto' : 'smooth');
          return;
        }
        const d = await get('/api/pages/' + slug(title));
        article.innerHTML = renderApi(d,title);
        const p = d.page || {};
        document.title = `${p.title || title} — OPS Occult Archive`;
        if (!opts.fromUrl) setTermUrl(p.title || title, !!opts.replace);
        resetEntryScroll(opts.fromUrl ? 'auto' : 'smooth');
      } catch (e) {
        article.innerHTML = `<div class="ops-library__article"><h2>Couldn’t open that entry</h2><p>${esc(e.message)}</p></div>`;
        resetEntryScroll('auto');
      }
    };

    const close = (fromHistory=false) => {
      if (reader) reader.hidden = true;
      if (index) index.hidden = false;
      root.classList.remove('is-reading');
      document.title = originalTitle;
      if (!fromHistory) setTermUrl('',false);
      if (!fromHistory) requestAnimationFrame(()=>root.querySelector('[data-library-browse]')?.scrollIntoView({behavior:'smooth',block:'start'}));
    };

    const openFrom = (e, selector='[data-title]') => { const x=e.target.closest(selector); if(x){open(x.dataset.title || x.dataset.relatedTitle);} };
    results.addEventListener('click', (e) => openFrom(e));
    results.addEventListener('keydown', (e) => { const x=e.target.closest('[data-title]'); if(x && (e.key==='Enter'||e.key===' ')){e.preventDefault();open(x.dataset.title);} });
    iceberg?.addEventListener('click',(e)=>{
      const random=e.target.closest('[data-random-rabbit]');
      if(random){ const items=editorialPack.entries||[]; if(items.length) open(items[Math.floor(Math.random()*items.length)].title); return; }
      openFrom(e);
    });
    topics?.addEventListener('click',(e)=>openFrom(e));
    azResults?.addEventListener('click',(e)=>openFrom(e));
    az?.addEventListener('click',(e)=>{const b=e.target.closest('[data-letter]');if(b && !b.disabled) drawAZ(b.dataset.letter);});
    browseTabs?.addEventListener('click',(e)=>{const b=e.target.closest('[data-browse-tab]');if(b)showBrowse(b.dataset.browseTab);});
    article.addEventListener('click',(e)=>{
      const related=e.target.closest('[data-related-title]'); if(related){open(related.dataset.relatedTitle);return;}
      const topic=e.target.closest('[data-topic-jump]'); if(topic){
        const targetName=topic.dataset.topicJump || '';
        close(false); showBrowse('topics');
        setTimeout(()=>{
          const target=[...root.querySelectorAll('[data-topic-name]')].find((x)=>x.dataset.topicName===targetName);
          (target || root.querySelector('[data-library-browse]'))?.scrollIntoView({behavior:'smooth',block:'start'});
          if(target){target.classList.add('is-highlighted');window.setTimeout(()=>target.classList.remove('is-highlighted'),1800);}
        },80);
      }
    });
    root.querySelector('[data-library-close]').onclick = () => close(false);

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const q=input.value.trim();
      if(!q){draw(all);return;}
      status.textContent='Searching…';
      const query=q.toLowerCase();
      const localMatches=(editorialPack.entries||[]).filter((x)=>JSON.stringify(x).toLowerCase().includes(query)).map(editorialSummary);
      try {
        const remote=((await get('/api/search?q='+encodeURIComponent(q))).results || []).filter(isPublishedRemote);
        draw(combined([...remote,...localMatches]));
      } catch(err){
        draw(combined(localMatches));
      }
    });

    window.addEventListener('popstate',()=>{
      const wanted=new URL(location.href).searchParams.get('term');
      if(!wanted){close(true);return;}
      const local=[...editorial.values()].find((x)=>x.slug===wanted || slugKey(x.title)===wanted);
      if(local) open(local.title,{fromUrl:true,replace:true});
    });

    drawIceberg();
    drawTopics();

    try {
      const [pages]=await Promise.all([get('/api/pages?limit=500')]);
      all=combined(pages.results||[]);
      draw(all);
    } catch(e) {
      all=combined([]);
      draw(all);
    }
    drawAZ('A');
    startGhostWriting();
    status.textContent=`${all.length} finished ${all.length===1?'entry':'entries'} in the public archive`;

    const wanted=new URL(location.href).searchParams.get('term');
    if(wanted){
      const local=[...editorial.values()].find((x)=>x.slug===wanted || slugKey(x.title)===wanted);
      if(local) open(local.title,{fromUrl:true,replace:true});
    }
  };

  const run=(s)=>s.querySelectorAll('[data-ops-library]').forEach(init);
  document.readyState==='loading' ? document.addEventListener('DOMContentLoaded',()=>run(document)) : run(document);
  document.addEventListener('shopify:section:load',(e)=>run(e.target));
})();
